import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Section, Empty, Badge } from "@/components/ui/kit";
import { fmtDate } from "@/utils/format";

export default function MyImpact() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/impact-updates").then(r => setItems(r.data.data)); }, []);
  return (
    <div className="space-y-8" data-testid="my-impact-page">
      <div className="rounded-3xl border border-emerald-900/15 bg-[#FDF6EE] p-8 lg:p-10">
        <div className="overline !text-orange-700">My Impact</div>
        <div className="mt-1 font-serif-display italic text-3xl text-emerald-950 leading-snug max-w-3xl">
          "Every rupee you gave has a face, a name, a photograph — and a next chapter."
        </div>
      </div>
      <Section title="Stories from the field" kicker="Photos • Videos • Reports">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map(u => {
            const img = u.media?.find(m => m.type === "IMAGE");
            return (
              <article key={u.id} data-testid={`impact-story-${u.id}`} className="rounded-xl border border-emerald-900/10 bg-white overflow-hidden">
                {img && <img src={img.url} alt="" className="w-full h-56 object-cover" />}
                <div className="p-5">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="overline">{fmtDate(u.date)}</div>
                    {u.purposeName && <Badge tone="brand">{u.purposeName}</Badge>}
                    {u.beneficiaryName && <Badge tone="warm">{u.beneficiaryName}</Badge>}
                  </div>
                  <h3 className="mt-2 font-display text-xl font-bold text-emerald-950">{u.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{u.description}</p>
                  {u.media?.some(m => m.type !== "IMAGE") && (
                    <div className="mt-3 flex flex-wrap gap-2 text-xs">
                      {u.media.filter(m => m.type !== "IMAGE").map((m, i) => (
                        <a key={i} href={m.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 px-2 py-1 rounded-full border border-emerald-900/15 hover:bg-emerald-50">
                          {m.type} • {m.caption || "Open"}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </article>
            );
          })}
          {!items.length && <div className="col-span-full"><Empty title="No impact updates yet" note="As projects deliver milestones, updates appear here." testid="impact-none" /></div>}
        </div>
      </Section>
    </div>
  );
}
